import { render, staticRenderFns } from "./FriendLinkIndex.vue?vue&type=template&id=84cad726&scoped=true"
import script from "./FriendLinkIndex.vue?vue&type=script&lang=js"
export * from "./FriendLinkIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cad726",
  null
  
)

export default component.exports